import { PayloadAction } from "@reduxjs/toolkit";
import { select } from "redux-saga/effects";
import { selectAuthAccountId } from "../../selectors/auth";
import { selectSelectedBrandIdState } from "../../selectors/brands";
import { BRANDS_MODELS_SCORE_DAILY_TABLE_NAME } from "../../const";
import { BrandScoreDailyRow } from "../types";
import { supabase } from "../../../lib/supabase";
import { format, subDays } from "date-fns";
import { throwOnSupabaseError } from "../../../utils/errors";
import { call, put } from "redux-saga/effects";
import { applySagaError } from "../../utils/saga";
import { fetchOverviewTopModelSuccess, fetchOverviewTopModelFailure } from "../slice";
import { FetchOverviewTopModelPayload } from "../payload.types";
import { selectModelsState } from "@/store/selectors/models";
import { Model } from "@/types/models";
import { getTopModelByVisibility } from "../utils/getTopModelByVisibility";



export function* fetchOverviewTopModelSaga( action: PayloadAction<FetchOverviewTopModelPayload>) {
    try {
      const {date, period} = action.payload;
      const userID: string | null = yield select(selectAuthAccountId);
      const selectedBrandId: number = yield select(selectSelectedBrandIdState);
      const models: Model[] = yield select(selectModelsState);
      let rows: BrandScoreDailyRow[];
  
      if (date) {
        const { data, error } = yield call(() =>
          supabase
            .from(BRANDS_MODELS_SCORE_DAILY_TABLE_NAME)
            .select("*")
            .eq("user_id", userID)
            .eq("brand_id", selectedBrandId)
            .eq("date", date)
            .order("date", { ascending: true })
        );
        throwOnSupabaseError(error);
        rows = (data ?? []) as BrandScoreDailyRow[];
      } else if (period) {
        const endDate = new Date();
        const startDate = subDays(endDate, period);
        const startStr = format(startDate, "yyyy-MM-dd");
        const endStr = format(endDate, "yyyy-MM-dd");
        const { data, error } = yield call(() =>
          supabase
            .from(BRANDS_MODELS_SCORE_DAILY_TABLE_NAME)
            .select("*")
            .eq("user_id", userID)
            .eq("brand_id", selectedBrandId)
            .gte("date", startStr)
            .lte("date", endStr)
            .order("date", { ascending: true })
        );
        throwOnSupabaseError(error);
        rows = (data ?? []) as BrandScoreDailyRow[];
      } else {
        throw new Error("scores.fetchOverviewTopModel: expected date or period");
      }
  
      const topModelId = getTopModelByVisibility(rows);
  
      if (topModelId == null || !models?.length) {
        yield put(fetchOverviewTopModelSuccess(null));
        return;
      }
  
      const model = models.find((m) => Number(m.id) === topModelId);
  
      if (!model) {
        yield put(fetchOverviewTopModelSuccess(null));
        return;
      }
  
      yield put(
        fetchOverviewTopModelSuccess({
          model_id: topModelId,
          name: model.name,
          iconType: model.data?.type ?? "",
        })
      );
    } catch (error) {
      yield* applySagaError(error, {
        operationName: "scores.fetchOverviewTopModel",
        failureAction: fetchOverviewTopModelFailure,
      });
    }
  }